var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 15C12.9167 16.6108 11.6109 17.9167 10 17.9167C8.38921 17.9167 7.08337 16.6108 7.08337 15",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0259 14.9987H3.97406C3.15996 14.9987 2.5 14.3387 2.5 13.5246C2.5 13.1337 2.6553 12.7588 2.93174 12.4823L3.43443 11.9796C3.90327 11.5108 4.16667 10.8749 4.16667 10.2119V7.91536C4.16667 4.69371 6.77834 2.08203 10 2.08203C13.2217 2.08203 15.8333 4.6937 15.8333 7.91536V10.2119C15.8333 10.8749 16.0967 11.5108 16.5656 11.9796L17.0682 12.4823C17.3447 12.7588 17.5 13.1337 17.5 13.5246C17.5 14.3387 16.84 14.9987 16.0259 14.9987Z",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBlack);
export default __webpack_public_path__ + "static/media/notification-black.2e6b325e95c2a7e4dfbc81ee6cfee74a.svg";
export { ForwardRef as ReactComponent };